import React from 'react';
import { Link } from 'react-router-dom';
function Footer(props) {
    return (
       
        <footer className="footer">
           
       <nav className="navbar navbar-default navbar-custom navbar-dark bg-secondary justify-content-center">
            <div className="container-fluid">
                {/* <div className="nav navbar-nav navbar-left">
                    <ul className="footerleft" style={{fontSize: 12}}>
                        <li>
                            <a href="http://charlessuits.org/sites/MrSuits.net/cv">About Me</a>                   
                        </li>
                        <li>
                            <a href="http://charlessuits.org/sites/MrSuits.net/bioroom">Biology</a>                    
                        </li>
                        <li>
                            <a href="http://charlessuits.org/sites/MrSuits.net/21st">21st Century</a>
                        </li>
                    </ul>
                </div>

                <div className="text-center center-block">
                    <a href="https://www.facebook.com/"><i id="social-fb" className="fa fa-facebook-square fa-lg social"></i></a>
                    <a href="https://twitter.com/?lang=en"><i id="social-tw" className="fa fa-twitter-square fa-lg social"></i></a>
                    <a href="https://news.google.com/topstories?hl=en-US&gl=US&ceid=US:en"><i id="social-gp" className="fa fa-google-plus-square fa-lg social"></i></a>
                    <a href="mailto: charles.suits@yahoo.com"><i id="social-em" className="fa fa-envelope-square fa-lg social"></i></a>
                </div>
                <div className="nav navbar-nav navbar-right">
                <ul style={{fontSize: 12}}>
                    <li>
                        <a href="https://www.charlessuits.org/sites/MrSuits.net/esmath">Mathematics</a>
                    </li>
                    <li>
                        <a href="https://www.charlessuits.org/sites/MrSuits.net/music">Music</a>
                    </li>
                    <li>
                        <a href="https://www.charlessuits.org/sites/MrSuits.net/renais">Renaissance</a>
                    </li>
                </ul>
            </div> */}

            </div>
            
        </nav> 
    </footer>
    );
}

export default Footer;